/* eslint-disable @next/next/no-img-element */
import React from "react";
import st from "./videoCover.module.scss";

type Props = {
  openVideoModal: () => void;
};

const VideoCover = (props: Props) => {
  return (
    <div className={st.videoResponsive}>
      <div
        onClick={props.openVideoModal}
        className={st.modalOpenImagesContainer}
      >
        <img
          src="https://www.datocms-assets.com/74813/1709075899-rockstar-homepage-hero.png"
          alt="play-youtube-cover"
        />
        <div className={st.youtubeShadow}>
          <div className={st["circle-wrapper"]}>
            <div className={st["big-circle"]} />
            <div className={st["small-circle"]}>
              <div className={st["play-button"]} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoCover;
